import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUserProfile = create(
        persist ((set) => ({
            profile: {
                mtcRef: 0,
                firstname: "",
                lastname: "",
                email: "",
                mobileNo: "",
                status: "",
            },
            setProfile: async (payload) =>{
                set((state) => ({
                    profile: {...state.profile, ...payload}
                }))
            }

        }),
        {
          name: 'userProfile-storage',
        }
    )
);

export default useUserProfile;